/**
 * The help drawer's section navigation — one horizontal tab per top-level
 * section (Welcome, Identity & Access, …), icon + label, matching the
 * project's existing `.nav-tabs` idiom (see the Users, Groups & Roles page).
 */
export default function HelpNav({ sections, activeSectionId, onSelect }) {
  return (
    <ul className="nav nav-tabs help-drawer__section-nav" role="tablist">
      {sections.map((section) => (
        <li className="nav-item" key={section.id} role="presentation">
          <button
            type="button"
            className={`nav-link${section.id === activeSectionId ? ' active' : ''}`}
            data-testid={`help-section-${section.id}`}
            role="tab"
            aria-selected={section.id === activeSectionId}
            onClick={() => onSelect(section.id)}
          >
            <i className={`${section.icon} me-2`} aria-hidden="true" />
            {section.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
